import { Box } from '@mui/material'
import { BUTTON_TRANSITION } from '../../theme/buttonHover'

export default function ButtonText({ children, sx = {} }) {
  return (
    <Box
      component="span"
      className="btn-text"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        zIndex: 2,
        display: 'inline-block',
        color: 'inherit',
        lineHeight: 'inherit',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      <Box
        component="span"
        className="btn-text-orig"
        sx={{
          display: 'inline-block',
          transition: BUTTON_TRANSITION,
          transform: 'translateY(0)',
        }}
      >
        {children}
      </Box>
      <Box
        component="span"
        className="btn-text-clone"
        aria-hidden
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          display: 'inline-block',
          transform: 'translateY(100%)',
          transition: BUTTON_TRANSITION,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
